// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__IzmOn","mobile":"style_mobile__72ppY","laptop":"style_laptop__J2ehP","v3":"style_v3__mD1Yy"};